package io.horion.cv.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.api.datasource.payement.PaymentMethod
import io.horion.cv.components.Footer
import io.horion.cv.components.PaymentFailedPopup
import io.horion.cv.components.Topbar
import io.horion.cv.di.koinGet
import io.horion.cv.pages.navigation.Screen
import io.horion.cv.styles.*
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import io.horion.cv.viewModel.PayViewModel
import org.jetbrains.compose.web.css.px

@Page("/payment-processing")
@Composable
fun PaymentProcessingPage() {
    val ctx = rememberPageContext()
    val payViewModel = koinGet<PayViewModel>()
    val payUiState = payViewModel.paymentUiState

    LaunchedEffect(Unit){
        if (payUiState.phone.isEmpty()){
            ctx.router.navigateTo(Screen.Payment.path)
        }
    }

    LaunchedEffect(Unit) {
        payViewModel.pollCvStatus()
    }

    LaunchedEffect(payUiState.paymentSuccess){
        if (payUiState.paymentSuccess) {
            ctx.router.navigateTo(Screen.PaymentSuccess.path)
        }
    }

    if(payUiState.error != null){
        PaymentFailedPopup(
            message = payUiState.error,
            onDismiss = {ctx.router.navigateTo("/payment")}
        )
    }

    val steps = listOf(
        "Une demande de paiement va apparaitre sur votre téléphone",
        "Saisissez votre code secret pour valider le paiement",
        "Si la fenêtre ne s'affiche pas, composez le ${if(payUiState.method == PaymentMethod.OM) "#150*50#" else "*126#"} "
    )
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val pageBg      = if (isDark) Colors.DarkBG    else Colors.White
    val titleColor  = if (isDark) Colors.White     else Colors.DarkBlue
    val textColor   = if (isDark) Colors.LightGray else Colors.DarkBlue
    val stepBg      = if (isDark) Colors.holder    else Colors.DarkBlue
    val stepNumColor = Colors.White

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(pageBg)
            .styleModifier { property("transition", "background-color 300ms ease") },
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Topbar()

        Column(
            modifier = ProcessingContainerStyle.toModifier(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                text = "Paiement en cours...",
                modifier = ProcessingTitleStyle.toModifier()
                    .fontWeight(FontWeight.Bold)
                    .fontFamily(INTER)
                    .color(titleColor)
            )

            Column(
                modifier = ProcessingStepsListStyle.toModifier(),
                horizontalAlignment = Alignment.Start
            ) {
                steps.forEachIndexed { index, stepText ->
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier.fillMaxWidth().gap(20.px)
                    ) {
                        Column(
                            modifier = ProcessingStepBadgeStyle.toModifier()
                                .borderRadius(50.px)
                                .backgroundColor(stepBg)
                                .styleModifier {
                                    property("flex-shrink", "0")
                                    property("transition", "background-color 300ms ease") },
                            horizontalAlignment = Alignment.CenterHorizontally,
                            verticalArrangement = Arrangement.Center
                        ) {
                            SpanText(
                                text = "${index + 1}",
                                modifier = ProcessingStepNumberStyle.toModifier()
                                    .fontWeight(FontWeight.Bold)
                                    .fontFamily(INTER)
                                    .color(stepNumColor)
                            )
                        }
                        SpanText(
                            text = stepText,
                            modifier = ProcessingStepTextStyle.toModifier()
                                .fontFamily(INTER)
                                .fontWeight(FontWeight.Normal)
                                .color(textColor)
                        )
                    }
                }
            }
        }
        Footer()
    }
}